import React, { useEffect } from 'react';
import { TouchableOpacity } from 'react-native';

import { IconPlayerButton } from './icon-audio-player-button/icon-player-button';
import type { IconAudioWithContextProps } from './icon-audio-player-with-context';
import styles from './icon-audio-player.style';
import { SPACE_KEY, useKeyPress } from '../../hooks/use-key-press';
import type { UseSound } from '../../hooks/use-sound';
import { ThemedText } from '../themed-text';

export interface IconAudioProps extends IconAudioWithContextProps {
  sound: UseSound;
}

export const IconAudioPlayer: React.FC<IconAudioProps> = ({
  active = true,
  text,
  color = 'onPrimary',
  fontSize = 'medium',
  sound,
  onReproduce,
}) => {
  const spacePress = useKeyPress(SPACE_KEY);
  const { play } = sound;

  useEffect(() => {
    if (spacePress && active) {
      play?.();
    }
  }, [active, play, spacePress]);

  useEffect(() => {
    if (onReproduce && sound.sliderValue === 1) {
      setTimeout(onReproduce, 700);
    }
  }, [onReproduce, sound.sliderValue]);

  return (
    <TouchableOpacity onPress={() => play?.()} style={styles.container}>
      <IconPlayerButton colors={color} size={fontSize} />
      <ThemedText type={color} fontSize={fontSize} style={styles.title}>
        {text}
      </ThemedText>
    </TouchableOpacity>
  );
};
